<template>
    <component
        class="el-button"
        :is="tag"
        :to="tag === 'router-link' ? to : null"
        :href="tag === 'a' ? href : null"
        :class="buttonClasses"
        @mouseenter="onMouseenter"
        @focus="onMouseenter"
        :style="styles"
        v-bind="attrs"
    >
        <div class="el-button__animation_border"></div>
        <div
            v-if="$slots['icon-left']"
            class="el-button__icon el-button__icon--left"
        >
            <slot name="icon-left"></slot>
        </div>
        <span v-if="$slots.default" class="el-button__text">
            <slot />
        </span>
        <div
            v-if="$slots['icon-right']"
            class="el-button__icon el-button__icon--right"
        >
            <slot name="icon-right"></slot>
        </div>
    </component>
</template>

<script>
export default {
    name: "ElLink",
    props: {
        type: {
            type: String,
            default: "default",
        },
        tag: {
            type: String,
            default: "router-link",
        },
        to: {
            required: false,
            default: null,
        },
        href: {
            type: String,
            default: null,
        },
        size: {
            type: String,
            default: "large",
        },
        circle: {
            type: Boolean,
            default: false,
        },
        simple: {
            type: Boolean,
            default: false,
        },
        square: {
            type: Boolean,
            default: false,
        },
        attrs: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            styles: {
                "--size-square": 0,
            },
        };
    },
    computed: {
        buttonClasses() {
            return {
                "is-circle": this.circle,
                "is-simple": this.simple,
                "is-square": this.square,
                [`is-${this.size}`]: true,
                [`type-${this.type}`]: true,
            };
        },
    },
    methods: {
        onMouseenter(e) {
            if (this.disabled || this.loading || !e) return;
            const button = e.currentTarget;
            if (!button) return;

            const ButtonStyles = getComputedStyle(button);
            const width = this.square
                ? this.varToNumber(ButtonStyles.width) + 20
                : this.varToNumber(ButtonStyles.width);
            this.styles = {
                "--size-square": width + "px",
            };
        },
        varToNumber(str) {
            return parseFloat(str);
        },
    },
};
</script>

<style lang="scss">
@import "../ElButton/style.scss";
</style>
